import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=7ed6b0ef&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed6b0ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed6b0ef')) {
      api.createRecord('7ed6b0ef', component.options)
    } else {
      api.reload('7ed6b0ef', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=7ed6b0ef&scoped=true&", function () {
      api.rerender('7ed6b0ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u77omFMFc92s/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports